<script>
	import { Modal, ModalBody, ModalHeader } from "sveltestrap";
	import { fetchIssueModal, bookingId } from "../../../../../store/store";
	import { onDestroy } from "svelte";
	import Tabs from "../../../../../components/Tabs/Tabs.svelte";
	import client from "../../../../../services/client";
	import Exterior from "./Exterior.svelte";
	import Drive from "./Drive.svelte";
	import Cleanliness from "./Cleanliness.svelte";
	let data;

	$: if ($fetchIssueModal) {
		fetchIssue();
	}

	const fetchIssue = async () => {
		try {
			data = "";
			const res = await client(`/v1/issues?bookingId=${$bookingId}`, {
				method: "GET",
				version: "vsr",
			});
			data = res.data;
		} catch (err) {
			console.log(err);
		}
	};
	const toggle = () => fetchIssueModal.set(false);

	onDestroy(() => {
		fetchIssueModal.set(false);
		data = {};
	});

	let items = [
		{
			label: "Exterior",
			value: 1,
			component: Exterior,
		},
		{
			label: "Drive",
			value: 2,
			component: Drive,
		},
		{
			label: "Cleanliness",
			value: 3,
			component: Cleanliness,
		},
	];
</script>

<div>
	<Modal isOpen={$fetchIssueModal} size={"xl"} scrollable>
		<ModalHeader {toggle}>Car Issues</ModalHeader>
		{#if data}
			<ModalBody>
				<Tabs issues={data} {items} />
			</ModalBody>
		{:else}
			<ModalBody>
				<div class="text-center">... Fetching issue data</div>
			</ModalBody>
		{/if}
	</Modal>
</div>
